
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services",
      function () {
        return require("private-next-pages/services.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services"])
      });
    }
  